module.exports = __webpack_public_path__ + "static/media/github-icon.9e6df2f4.svg";